{
  "api/v1/customer/me": {
    "response": {
      "current_user": {
        "id": 990010,
        "role": "owner",
        "name": "Preview User",
        "email": "preview@tidy.local"
      },
      "customer_account": {
        "id": 990000,
        "account_type": "rental",
        "account_name": "Preview Portfolio",
        "advanced_mode": false,
        "first_booking": false,
        "created_at": "2025-01-15T12:00:00Z"
      },
      "account_manager": null
    }
  },
  "api/v1/customer/dashboard/reports": {
    "response": [
      {
        "id": 990101,
        "name": "Overview",
        "type": "overview",
        "default_date_key": "jobs.start_datetime_local"
      }
    ]
  },
  "api/v1/customer/workflow-usage-summary": {
    "response": {
      "breakdown_by_days": {
        "{{DATE(-6,ISO)}}": {
          "run_count": 4,
          "action_run_data": {
            "automation": {
              "count": 3
            },
            "concierge": {
              "count": 1
            }
          }
        },
        "{{DATE(-5,ISO)}}": {
          "run_count": 2,
          "action_run_data": {
            "automation": {
              "count": 2
            },
            "concierge": {
              "count": 0
            }
          }
        },
        "{{DATE(-4,ISO)}}": {
          "run_count": 6,
          "action_run_data": {
            "automation": {
              "count": 4
            },
            "concierge": {
              "count": 2
            }
          }
        },
        "{{DATE(-3,ISO)}}": {
          "run_count": 3,
          "action_run_data": {
            "automation": {
              "count": 2
            },
            "concierge": {
              "count": 1
            }
          }
        },
        "{{DATE(-2,ISO)}}": {
          "run_count": 5,
          "action_run_data": {
            "automation": {
              "count": 3
            },
            "concierge": {
              "count": 2
            }
          }
        },
        "{{DATE(-1,ISO)}}": {
          "run_count": 7,
          "action_run_data": {
            "automation": {
              "count": 5
            },
            "concierge": {
              "count": 2
            }
          }
        },
        "{{DATE(0,ISO)}}": {
          "run_count": 3,
          "action_run_data": {
            "automation": {
              "count": 2
            },
            "concierge": {
              "count": 1
            }
          }
        }
      }
    }
  },
  "api/v1/customer/addresses": {
    "response": [
      {
        "id": 990001,
        "address_name": "Palmetto House",
        "address1": "1124 Palmetto Ave",
        "address2": null,
        "city": "Charleston",
        "state": "SC",
        "add_state": "SC",
        "zip": "29403",
        "country_code": "US",
        "timezone": "America/New_York",
        "latitude": 32.801,
        "longitude": -79.937,
        "color": "#4A90D9",
        "region_id": 1,
        "default_address_task_list_state": "active",
        "custom_fields": [],
        "plans": [],
        "usdz_url": null,
        "json_url": null,
        "remote_access_address": null,
        "next_job": null,
        "last_job": null,
        "unpaid_invoices_count": 0,
        "maintenance_due_next_month_count": 0,
        "low_inventory_count": 0,
        "open_issues_count": 0,
        "bed_count": 4,
        "bath_count": 2,
        "living_area_sqft": 1950,
        "lot_size_sqft": 6500,
        "year_built": 1948,
        "property_type": "single_family",
        "wifi_network": "PalmettoHouse_5G",
        "wifi_password": "charleston1948",
        "compliance_check_status": "completed",
        "integration": null,
        "automatic_booking_enabled": false,
        "address_automatic_booking_setting": null
      },
      {
        "id": 990002,
        "address_name": "Ferncreek Rooming House",
        "address1": "68 Ferncreek Ln",
        "address2": null,
        "city": "Orlando",
        "state": "FL",
        "add_state": "FL",
        "zip": "32803",
        "country_code": "US",
        "timezone": "America/New_York",
        "latitude": 28.5421,
        "longitude": -81.3492,
        "color": "#E8A33D",
        "region_id": 1,
        "default_address_task_list_state": "active",
        "custom_fields": [],
        "plans": [],
        "usdz_url": null,
        "json_url": null,
        "remote_access_address": null,
        "next_job": null,
        "last_job": null,
        "unpaid_invoices_count": 1,
        "maintenance_due_next_month_count": 0,
        "low_inventory_count": 0,
        "open_issues_count": 1,
        "bed_count": 3,
        "bath_count": 1,
        "living_area_sqft": 1400,
        "lot_size_sqft": 4800,
        "year_built": 1962,
        "property_type": "single_family",
        "wifi_network": "Ferncreek_Guest",
        "wifi_password": "orlando1962",
        "compliance_check_status": "processing",
        "integration": null,
        "automatic_booking_enabled": false,
        "address_automatic_booking_setting": null
      },
      {
        "id": 990003,
        "address_name": "Cadence Cottage",
        "address1": "512 Cadence Way",
        "address2": null,
        "city": "Boise",
        "state": "ID",
        "add_state": "ID",
        "zip": "83702",
        "country_code": "US",
        "timezone": "America/Boise",
        "latitude": 43.615,
        "longitude": -116.2023,
        "color": "#5FA777",
        "region_id": 1,
        "default_address_task_list_state": "active",
        "custom_fields": [],
        "plans": [],
        "usdz_url": null,
        "json_url": null,
        "remote_access_address": null,
        "next_job": null,
        "last_job": null,
        "unpaid_invoices_count": 0,
        "maintenance_due_next_month_count": 1,
        "low_inventory_count": 0,
        "open_issues_count": 0,
        "bed_count": 2,
        "bath_count": 2,
        "living_area_sqft": 1280,
        "lot_size_sqft": 5200,
        "year_built": 2005,
        "property_type": "single_family",
        "wifi_network": "CadenceCottage",
        "wifi_password": "boise2005",
        "compliance_check_status": "completed",
        "integration": null,
        "automatic_booking_enabled": false,
        "address_automatic_booking_setting": null
      }
    ]
  },
  "api/v1/customer/addresses/*": {
    "byPathParam": {
      "990001": {
        "id": 990001,
        "address_name": "Palmetto House",
        "address1": "1124 Palmetto Ave",
        "address2": null,
        "city": "Charleston",
        "state": "SC",
        "add_state": "SC",
        "zip": "29403",
        "country_code": "US",
        "timezone": "America/New_York",
        "latitude": 32.801,
        "longitude": -79.937,
        "color": "#4A90D9",
        "region_id": 1,
        "default_address_task_list_state": "active",
        "custom_fields": [],
        "plans": [],
        "usdz_url": null,
        "json_url": null,
        "remote_access_address": null,
        "next_job": null,
        "last_job": null,
        "unpaid_invoices_count": 0,
        "maintenance_due_next_month_count": 0,
        "low_inventory_count": 0,
        "open_issues_count": 0,
        "bed_count": 4,
        "bath_count": 2,
        "living_area_sqft": 1950,
        "lot_size_sqft": 6500,
        "year_built": 1948,
        "property_type": "single_family",
        "wifi_network": "PalmettoHouse_5G",
        "wifi_password": "charleston1948",
        "compliance_check_status": "completed",
        "integration": null,
        "automatic_booking_enabled": false,
        "address_automatic_booking_setting": null
      },
      "990002": {
        "id": 990002,
        "address_name": "Ferncreek Rooming House",
        "address1": "68 Ferncreek Ln",
        "address2": null,
        "city": "Orlando",
        "state": "FL",
        "add_state": "FL",
        "zip": "32803",
        "country_code": "US",
        "timezone": "America/New_York",
        "latitude": 28.5421,
        "longitude": -81.3492,
        "color": "#E8A33D",
        "region_id": 1,
        "default_address_task_list_state": "active",
        "custom_fields": [],
        "plans": [],
        "usdz_url": null,
        "json_url": null,
        "remote_access_address": null,
        "next_job": null,
        "last_job": null,
        "unpaid_invoices_count": 1,
        "maintenance_due_next_month_count": 0,
        "low_inventory_count": 0,
        "open_issues_count": 1,
        "bed_count": 3,
        "bath_count": 1,
        "living_area_sqft": 1400,
        "lot_size_sqft": 4800,
        "year_built": 1962,
        "property_type": "single_family",
        "wifi_network": "Ferncreek_Guest",
        "wifi_password": "orlando1962",
        "compliance_check_status": "processing",
        "integration": null,
        "automatic_booking_enabled": false,
        "address_automatic_booking_setting": null
      },
      "990003": {
        "id": 990003,
        "address_name": "Cadence Cottage",
        "address1": "512 Cadence Way",
        "address2": null,
        "city": "Boise",
        "state": "ID",
        "add_state": "ID",
        "zip": "83702",
        "country_code": "US",
        "timezone": "America/Boise",
        "latitude": 43.615,
        "longitude": -116.2023,
        "color": "#5FA777",
        "region_id": 1,
        "default_address_task_list_state": "active",
        "custom_fields": [],
        "plans": [],
        "usdz_url": null,
        "json_url": null,
        "remote_access_address": null,
        "next_job": null,
        "last_job": null,
        "unpaid_invoices_count": 0,
        "maintenance_due_next_month_count": 1,
        "low_inventory_count": 0,
        "open_issues_count": 0,
        "bed_count": 2,
        "bath_count": 2,
        "living_area_sqft": 1280,
        "lot_size_sqft": 5200,
        "year_built": 2005,
        "property_type": "single_family",
        "wifi_network": "CadenceCottage",
        "wifi_password": "boise2005",
        "compliance_check_status": "completed",
        "integration": null,
        "automatic_booking_enabled": false,
        "address_automatic_booking_setting": null
      }
    }
  }
}
